var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('router-view'),(_setup.errorAlert)?_c(_setup.ErrorModal):_vm._e(),_c(_setup.BeforeLogoutModal),_c('p',{staticClass:"app-version-text"},[_vm._v(" "+_vm._s(_setup.appVersion)+" ")]),(_setup.testCafe)?_c('div',{staticClass:"testcafe-bar"},[_vm._v(" Tryb Testcafe ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }